/**
 * AgentHorizontal
 * 
 * @Author: Focci
 * @Date: 2024-01-16 16:33:47
 * @Last Modified by: Focci
 * @Last Modified time: 2024-01-16 16:33:47
 */

'use client'

import PropTypes from 'prop-types'
import useTracking from '@hook/useTracking'
import clsx from 'clsx'
import AgentAvatar from '@comp/page/agent/AgentAvatar'
// import Image from 'next/image'
import Link from 'next/link'
import { useLocale } from 'next-intl'
// import { imageSize } from '@lib/image/loader'
import { detail } from '@lib/route/agent'
import { houseToGta, isAU, toSlug } from '@lib/utils'
import { useMemo } from 'react'
import PhoneButton from './PhoneButton'

export default function AgentHorizontal({
  agent,
  size = 110,
  trackParams,
  bordered = true,
  nameClassname = 'text-base',
  house
}) {
  const locale = useLocale()
  const { pushTrack } = useTracking()
  const href = useMemo(() => {
    const { name, slug, id } = agent
    const pathname = slug || toSlug(`${name}-${id}`)

    return detail(pathname, locale)
  }, [agent, locale])

  function clickHandle() {
    isAU && pushTrack('homely_agent_profile_click', houseToGta(house))
  }
  
  return (
    <div 
      className={clsx([
        'p-4 flex items-center gap-x-4',
        bordered && 'border-b'
      ])}
    >
      <Link 
        className="shrink-0 rounded-full bg-cf8" 
        style={{ width: `${size}px`, height: `${size}px` }}
        href={href}
        onClick={clickHandle}
      >
        {agent.avatar && (
          <AgentAvatar 
            name={agent.name}
            avatar={agent.avatar}
            membershipLevel={agent.membershipLevel}
            width={size}
            height={size}
            wrapperClassName="w-full h-full rounded-full"
            className="w-full h-full object-cover rounded-full object-top"
          />
          // <Image
          //   priority 
          //   unoptimized={true}
          //   width={size}
          //   height={size}
          //   src={imageSize(agent.avatar, size) || ''}
          //   alt={agent.name || 'Agent'}
          //   className="w-full h-full object-cover rounded-full object-top"
          // />
        )}
      </Link>
      <div className="flex-auto">
        <Link
          href={href}
          onClick={clickHandle}
          className={clsx(['font-medium', nameClassname])}
        >
          {agent.name}
        </Link>
        {agent.language && (
          <div className="text-f.6 text-helper">
            {agent.language}
          </div>
        )}
        {agent.phone && (
          <div className="mt-2">
            <PhoneButton 
              agentId={agent.id} 
              phone={agent.phone} 
              trackParams={trackParams} 
              house={house}
            />
          </div>
        )}
      </div>
    </div>
  )
}

AgentHorizontal.propTypes = {
  agent: PropTypes.object,
  // trackParams: PropTypes.object,
}
